import { cva } from "class-variance-authority";

export { default as Tooltip } from "./Tooltip.vue";
export { default as TooltipArrow } from "./TooltipArrow.vue";

export const sizes = ["xs", "sm", "md", "lg", "xl", "2xl"];
export const contentVariants = cva(
    [
        "bg-primary-solid",
        "p-3",
        "rounded-md",
        "flex",
        "flex-col",
        "gap-1",
        "animate-tooltip-open",
        "data-[state:closed]:animate-tooltip-close",
        "z-50",
    ],
    {
        variants: {
            size: {
                xs: "max-w-xs",
                sm: "max-w-sm",
                md: "max-w-md",
                lg: "max-w-lg",
                xl: "max-w-xl",
                "2xl": "max-w-2xl",
            },
        },
    }
);
